/* ============================================================================
 * product-filter
 * ============================================================================
 */
;(function () {
  function main () {
    const sorting = document.querySelector('.product-filter-sorting')

    if (!sorting) {
      return
    }

    const sortByInput = document.querySelector('[name="sort_by"]')

    if (!sortByInput) {
      return
    }

    sorting.addEventListener('change', function (event) {
      sortByInput.value = sorting.value
      sortByInput.form.submit()
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main, { once: true })
  } else {
    main()
  }
})()
